import HeaderSubSection from "../../components/HeaderSubSection/index.vue";
import articlesDetailesSection from "../../components/articlesDetailesSection/index.vue";
import relatedArticlesSection from "../../components/relatedArticlesSection/index.vue";

export default {
  name: "articleDetailePage",
  components: {
    HeaderSubSection,
    articlesDetailesSection,
    relatedArticlesSection,
  },
};
